import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError';
import { Toast } from '../../../../../../Notification';

const updateTourPayTransaction = async ({ state, userId, editTourPayTransaction, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { tourPayTransactionId, tourId, payTransactionId, units, jobElementId, waived, billable, internalRemark, remark,
    timeKeeperComment, cost, tourStartTime } = itemDetails;
  let parameters = {
    tourPayTransactionId,
    tourId,
    payTransactionId,
    units: units || 0,
    jobElementId: jobElementId || 0,
    waived: waived || false,
    billable: billable || false,
    internalRemark: internalRemark || " ",
    remark: remark || " ",
    timeKeeperComment: timeKeeperComment || " ",
    updatingUserId: userId,
    baseRate: cost || 0
  };
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Pay Transaction Updated', description: `For ${resource.name} on ${day}`};
  try {
    await editTourPayTransaction(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editTourPayTransaction',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Updating Pay Transaction Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default updateTourPayTransaction;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/payTransaction/updateTourPayTransaction.js